import debounce from 'lodash/debounce';
import { useEffect, useRef, useState } from 'react';

export function useCalcDivSize(ref: React.RefObject<HTMLDivElement>) {
  const [width, setWidth] = useState<number>(0);
  const [height, setHeight] = useState<number>(0);
  const [isLoadingSize, setIsLoadingSize] = useState<boolean>(true);
  const rafIdRef = useRef<number>(0);

  const updateSize = debounce(() => {
    cancelAnimationFrame(rafIdRef.current);
    rafIdRef.current = requestAnimationFrame(() => {
      if (ref.current) {
        const { width: measuredWidth, height: measuredHeight } = ref.current.getBoundingClientRect();
        setWidth(measuredWidth);
        setHeight(measuredHeight);
        setIsLoadingSize(false);
      }
    });
  }, 50);

  useEffect(() => {
    updateSize();
    const handleResize = () => {
      setIsLoadingSize(true);
      updateSize();
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      cancelAnimationFrame(rafIdRef.current);
    };
  }, [ref]);

  return { width, height, isLoadingSize };
}
